/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React, { useState } from 'react';
import { Modal, ModalBody, ModalHeader, FormGroup } from 'reactstrap';
import { saveReportingLevelDetails } from '../../../actions/initiative';
import SDGSelector from '@features/update-materiality-modal/SDGSelector';
import { IndustryLevels, InitiativeData } from '../../../types/initiative';
import IndustrySectorSelector, { getDefaultIcb2019 } from '@features/industry-sector-selector';
import './MaterialityModal.scss';
import { useAppDispatch } from '@reducers/index';

interface MaterialityProps {
  initiative?: InitiativeData;
  isOpen: boolean;
  toggle: () => void;
  handleReload: () => void;
}

export const MaterialityModal = (props: MaterialityProps) => {
  const dispatch = useAppDispatch();
  const { isOpen, toggle, initiative, handleReload } = props;
  const initiativeIndustry = getDefaultIcb2019(initiative?.industry?.icb2019);
  const [industrySector, setIndustrySector] = useState<IndustryLevels>();

  const handleIndustrySector = (icb2019: IndustryLevels) => {
    setIndustrySector(icb2019);
  };

  if (!initiative) {
    return <></>;
  }

  const handleUpdateInitiativeIndustry = () => {
    const newInitiativeData = { files: [], industry: { ...initiative.industry, icb2019: industrySector } };
    dispatch(saveReportingLevelDetails(initiative._id, newInitiativeData));
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop='static' className='modal-materiality'>
      <ModalHeader toggle={toggle}>Industry and materiality</ModalHeader>
      <ModalBody>
        <div className='row'>
          <div className='col'>
            <div className='modal-materiality__title mb-2 strong'>
              <i className='fa-solid fa-industry-alt mr-2' />
              Your industry
            </div>
            <FormGroup>
              <IndustrySectorSelector industry={initiativeIndustry} handleIndustrySector={handleIndustrySector} />
            </FormGroup>
            <div className='modal-materiality__divider' />
            <div className='mt-3'>
              <div className='modal-materiality__title mb-2 strong'>
                <i className='fa fa-tachometer-alt mr-2' />
                Your materiality
              </div>
              <SDGSelector
                toggle={toggle}
                handleReload={handleReload}
                initiative={initiative}
                callbackSubmit={handleUpdateInitiativeIndustry}
              />
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
